import React, { useState } from "react";
import { MessageCircle } from "lucide-react";
import { useLang } from "@/i18n";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from "@/components/ui/dialog";

export const WHATSAPP_CONTACTS = [
  { label: "+237 6 55 59 58 95", number: "237655595895" },
  { label: "+237 6 53 60 27 07", number: "237653602707" },
];

export const waLink = (number, message) =>
  `https://wa.me/${number}?text=${encodeURIComponent(message || "")}`;

export const WhatsAppDialog = ({
  message,
  triggerLabel,
  triggerClassName = "ab-btn-primary",
  triggerIcon,
  triggerTestId,
  onTriggerClick,
  title,
  description,
}) => {
  const { lang } = useLang();
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          data-testid={triggerTestId}
          onClick={() => onTriggerClick && onTriggerClick()}
          className={triggerClassName}
        >
          {triggerIcon}
          {triggerLabel}
        </button>
      </DialogTrigger>
      <DialogContent className="bg-ab-ebony border border-ab-gold/25 text-ab-ivory max-w-md" data-testid="whatsapp-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-ab-ivory">
            {title || (lang === "fr" ? "Continuer sur WhatsApp" : "Continue on WhatsApp")}
          </DialogTitle>
          <DialogDescription className="text-ab-ivory/60">
            {description ||
              (lang === "fr"
                ? "Choisissez un numéro : la conversation s'ouvrira avec un message déjà rempli."
                : "Choose a number: the chat opens with a pre-filled message.")}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 mt-2">
          {WHATSAPP_CONTACTS.map((c) => (
            <a
              key={c.number}
              href={waLink(c.number, message)}
              target="_blank"
              rel="noreferrer"
              onClick={() => setOpen(false)}
              data-testid={`whatsapp-contact-${c.number}`}
              className="flex items-center justify-center gap-2.5 w-full py-3.5 rounded-full bg-[#25D366] text-white font-semibold tracking-wide hover:bg-[#1ebe57] transition-colors"
            >
              <MessageCircle size={18} /> {c.label}
            </a>
          ))}
        </div>
        <p className="text-center text-ab-ivory/40 text-xs mt-1">
          {lang === "fr" ? "Vous serez redirigé vers WhatsApp." : "You will be redirected to WhatsApp."}
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default WhatsAppDialog;
